"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = usePixelsDebugPanel;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _ = require("..");
var _PixelmonBridgeWrapper = _interopRequireDefault(require("./PixelmonBridgeWrapper"));
var _PixelmonDebugPanel = _interopRequireDefault(require("./PixelmonDebugPanel"));
function usePixelsDebugPanel(projectId, appId, weSdkVersion) {
  // Do this asynchronously / with state and a useEffect hook because if we did it at top-level,
  // a server-side render wouldn't have document available and the logic wouldn't run / parse
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showPixelsDebug = _useState2[0],
    setShowPixelsDebug = _useState2[1];
  (0, _react.useEffect)(function () {
    if (typeof document === 'undefined') {
      return;
    }
    var queryParams = new URL((document || {}).location || '').searchParams;
    var pixelsDebugPanelParam = queryParams.get('pixelsDebugPanel');
    var shouldShow = pixelsDebugPanelParam === 'true';
    setShowPixelsDebug(shouldShow);
  }, []);
  var debugPanel = null;
  if (showPixelsDebug === true) {
    debugPanel = /*#__PURE__*/_react["default"].createElement(_PixelmonBridgeWrapper["default"], {
      pixelmonInstance: (0, _.getPixelmonInstance)(),
      projectId: projectId,
      appId: appId,
      weSdkVersion: weSdkVersion
    }, /*#__PURE__*/_react["default"].createElement(_PixelmonDebugPanel["default"], null));
  }
  return debugPanel;
}